function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "#073C50",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M5.58057682,7.31240173 L5.58079173,18 L2.26448039,18 L2.26448039,7.31240173 L5.58057682,7.31240173 Z M14.0222725,7.04638379 C17.3800165,7.04638379 18,9.26011746 18,12.1372831 L18,12.1372831 L18,17.9997849 L14.6869088,17.9997849 L14.686044,12.5417675 C14.6758161,11.3507651 14.5470512,9.9687101 12.9632769,9.9687101 C11.2387863,9.9687101 10.9736617,11.3187995 10.9736617,12.7125442 L10.9736617,12.7125442 L10.9736617,17.9997849 L7.6599268,17.9997849 L7.6599268,7.31240173 L10.8405626,7.31240173 L10.8405626,8.77259715 L10.885001,8.77259715 L10.956212,8.64633952 C11.4373997,7.84600745 12.4904644,7.04638379 14.0222725,7.04638379 Z M3.92328004,2 C4.98356362,2 5.8448428,2.8627841 5.8448428,3.92513541 C5.8448428,4.98856198 4.98356362,5.85156115 3.92328004,5.85156115 C2.86042054,5.85156115 2,4.98856198 2,3.92513541 C2.00021441,2.8632142 2.86084986,2 3.92328004,2 Z"
}));

var SvgLinkedin = function SvgLinkedin(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLinkedin, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/linkedin.746300c3.svg";
export { ForwardRef as ReactComponent };